// Color names based on http://chir.ag/projects/name-that-color/
export enum Colors {
  ALABASTER = "#FAFAFA",
  BLACK = "#000000",
  ECSTASY = "#FA8320",
}
